import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "./App.css";
import DetailsSup from "./components/suppliers/detailsSup";
import Suppliers from "./components/suppliers/suppliers";
import UpdateSup from "./components/suppliers/updateSup";

import DetailsProd from "./components/product/detailsProd";
import Product from "./components/product/product";
import ProductHistory from "./components/product/ProductHistory";
import UpdateProd from "./components/product/updateProd";

import DetailsPurch from "./components/purchase/detailsPurch";
import Purchase from "./components/purchase/purchase";

import Login from "./components/user/Login";
import Signup from "./components/user/Signup";
import Logout from "./components/user/Logout";
import ForgotPassword from "./components/user/ForgotPassword";
import LoginWithCode from "./components/user/LoginWithCode";
import ChangePassword from "./components/user/ChangePassword";
import UserList from "./components/user/user";
import SuperAdminLogin from "./components/superAdmin/SuperAdminLogin";
import SuperAdminDashboard from "./components/superAdmin/SuperAdminDashboard";
import UserManagement from "./components/superAdmin/UserManagement";
import CompanyManagement from "./components/superAdmin/CompanyManagement";
import CompanyDataView from "./components/superAdmin/CompanyDataView";
import ProductManagement from "./components/superAdmin/ProductManagement";
import BookPublisherManagement from "./components/superAdmin/BookPublisherManagement";
import ProductCategoryManagement from "./components/superAdmin/ProductCategoryManagement";
import ProductCurrencyManagement from "./components/superAdmin/ProductCurrencyManagement";

import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import Customer from "./components/customer/customer";
import DetailCust from "./components/customer/detailCust";
import UpdateCust from "./components/customer/updateCust";
import Pos from "./components/pos/pos";
import DetailSale from "./components/sale/detailSale";
import Sale from "./components/sale/sale";

import Page404 from "./components/404/404Page";
import Dashboard from "./components/Dashboard/Graph/Dashboard";
import AddCustPaymentByInvoice from "./components/Payment/CustomerPaymentByInvoice";
import AddSupPaymentByInvoice from "./components/Payment/SupplierPaymentByInvoice";
import GetAllPurch from "./components/purchase/getAllPurch";
import GetAllSale from "./components/sale/getAllSale";
import DetailStaff from "./components/user/detailsStaff";
import UpdateStaff from "./components/user/updateStaff";

// import Register from "./components/user/Register";
import { Layout } from "antd";
import Account from "./components/account/account";
import BalanceSheet from "./components/account/balanceSheet";
import DetailAccount from "./components/account/detailAccount";
import IncomeStatement from "./components/account/incomeStatement";
import TrialBalance from "./components/account/trialBalance";
import ProfitAndLoss from "./components/account/profitAndLoss";
import PartyWiseProfitLoss from "./components/account/partyWiseProfitLoss";
import PartyStatement from "./components/account/partyStatement";
import CustomerSupplierSummaryReport from "./components/account/CustomerSupplierSummaryReport";
import Designation from "./components/designation/designation";
import DetailDesignation from "./components/designation/detailDesignation";
import UpdateDesignation from "./components/designation/updateDesignation";
import Main from "./components/layouts/Main";
import DetailProductCategory from "./components/productCategory/detailProductCategory";
import ProductCategory from "./components/productCategory/productCategory";
import UpdateProductCategory from "./components/productCategory/updateProductCategory";
import AddReturnPurchase from "./components/purchase/addReturnPurchase";
import AddPermission from "./components/role/AddPermission";
import DetailRole from "./components/role/DetailsRole";
import RoleList from "./components/role/role";
import AddReturnSale from "./components/sale/addReturnSale";
import EditSale from "./components/sale/editSale";
import SalesOrderList from "./components/sale/salesOrder/SalesOrderList";
import AddSalesOrder from "./components/sale/salesOrder/AddSalesOrder";
import SalesOrderDetails from "./components/sale/salesOrder/SalesOrderDetails";
import InvoiceSetting from "./components/settings/invoiceSetting";
import PurchaseOrderList from "./components/purchase/purchaseOrder/PurchaseOrderList";
import AddPurchaseOrder from "./components/purchase/purchaseOrder/AddPurchaseOrder";
import PurchaseOrderDetails from "./components/purchase/purchaseOrder/PurchaseOrderDetails";
import SalesOrderReports from "./components/sale/salesOrder/SalesOrderReports";
import PurchaseOrderReports from "./components/purchase/purchaseOrder/PurchaseOrderReports";
import Location from "./components/location/location";
import AddTransaction from "./components/transaction/AddTransaction";
import DetailTransaction from "./components/transaction/detailTransaction";
import Transaction from "./components/transaction/transaction";

import DetailBookPublisher from "./components/bookPublisher/detailBookPublisher";
import BookPublisher from "./components/bookPublisher/bookPublisher";
import UpdateBookPublisher from "./components/bookPublisher/updateBookPublisher";

import DetailProductCurrency from "./components/productCurrency/detailProductCurrency";
import ProductCurrency from "./components/productCurrency/productCurrency";
import UpdateProductCurrency from "./components/productCurrency/updateProductCurrency";

import DetailPartyDiscount from "./components/partyDiscount/detailPartyDiscount";
import PartyDiscount from "./components/partyDiscount/partyDiscount";

import DetailDiscountMaster from "./components/discountMaster/detailDiscountMaster";
import DiscountMaster from "./components/discountMaster/discountMaster";
import AddDiscountMaster from "./components/discountMaster/addDiscountMaster";
import UpdatePartyDiscount from "./components/partyDiscount/updatePartyDiscount";

const { Sider } = Layout;

function App() {
  return (
    <div className="App container-fluid">
      <BrowserRouter>
        <Main>
          <ToastContainer />
          <Routes>
            <Route path="/dashboard" element={<Dashboard />}></Route>
            <Route path="/" element={<Dashboard />} />
            <Route path="*" element={<Page404 />} />

            <Route path="/supplier" exact element={<Suppliers />} />
            <Route path="/supplier/:id" element={<DetailsSup />} />
            <Route path="/supplier/:id/update" element={<UpdateSup />} />

            <Route path="/product" exact element={<Product />} />
            <Route path="/product-history" exact element={<ProductHistory />} />
            <Route path="/product/:id" element={<DetailsProd />} />
            <Route path="/product/:id/update" element={<UpdateProd />} />

            <Route
              path="/product-category"
              exact
              element={<ProductCategory />}
            />
            <Route
              path="/product-category/:id"
              element={<DetailProductCategory />}
            />
            <Route
              path="/product-category/:id/update"
              element={<UpdateProductCategory />}
            />

            <Route
              path="/book-publisher"
              exact
              element={<BookPublisher />}
            />
            <Route
              path="/book-publisher/:id"
              element={<DetailBookPublisher />}
            />
            <Route
              path="/book-publisher/:id/update"
              element={<UpdateBookPublisher />}
            />

            <Route
              path="/product-currency"
              exact
              element={<ProductCurrency />}
            />
            <Route
              path="/product-currency/:id"
              element={<DetailProductCurrency />}
            />
            <Route
              path="/product-currency/:id/update"
              element={<UpdateProductCurrency />}
            />

            <Route
              path="/discount-master"
              exact
              element={<DiscountMaster />}
            />
            <Route
              path="/discount-master/add"
              exact
              element={<AddDiscountMaster />}
            />
            <Route
              path="/discount-master/:id"
              element={<DetailDiscountMaster />}
            />
            <Route
              path="/discount-master/:id/update"
              element={<AddDiscountMaster />}
            />

<Route
              path="/party-discount"
              exact
              element={<PartyDiscount />}
            />
            <Route
              path="/party-discount/:id"
              element={<DetailPartyDiscount />}
            />
            <Route
              path="/party-discount/:id/update"
              element={<UpdatePartyDiscount />}
            />

            <Route path="/purchase" exact element={<Purchase />} />
            <Route path="/purchase/edit/:id" element={<Purchase />} />
            <Route path="/purchaselist" exact element={<GetAllPurch />} />
            <Route path="/purchase/:id" element={<DetailsPurch />} />
            <Route
              path="/purchase/return/:id"
              element={<AddReturnPurchase />}
            />

            <Route path="/customer" exact element={<Customer />} />
            <Route path="/customer/:id" element={<DetailCust />} />
            <Route path="/customer/:id/update" element={<UpdateCust />} />

            <Route path="/sale" exact element={<Sale />} />
            <Route path="/salelist" exact element={<GetAllSale />} />
            <Route path="/sale/:id" element={<DetailSale />} />
            <Route path="/sale/:id/update" element={<UpdateProd />} />
            <Route path="/sale/return/:id" element={<AddReturnSale />} />
            <Route path="/sale/edit/:id" element={<EditSale />} />
            
            <Route path="/sales-order" exact element={<SalesOrderList />} />
            <Route path="/sales-order/add" exact element={<AddSalesOrder />} />
            <Route path="/sales-order/edit/:id" exact element={<AddSalesOrder />} />
            <Route path="/sales-order/reports" exact element={<SalesOrderReports />} />
            <Route path="/sales-order/:id" element={<SalesOrderDetails />} />
            
            <Route path="/purchase-order" exact element={<PurchaseOrderList />} />
            <Route path="/purchase-order/add" exact element={<AddPurchaseOrder />} />
            <Route path="/purchase-order/edit/:id" exact element={<AddPurchaseOrder />} />
            <Route path="/purchase-order/reports" exact element={<PurchaseOrderReports />} />
            <Route path="/purchase-order/:id" element={<PurchaseOrderDetails />} />
            
            <Route
              path="/payment/supplier/:pid"
              exact
              element={<AddSupPaymentByInvoice />}
            />
            <Route
              path="/payment/customer/:pid"
              exact
              element={<AddCustPaymentByInvoice />}
            />
            <Route path="/transaction" exact element={<Transaction />} />
            <Route
              path="/transaction/create"
              exact
              element={<AddTransaction />}
            />
            <Route path="/transaction/:id" element={<DetailTransaction />} />

            <Route path="/auth/login" exact element={<Login />} />
            <Route path="/auth/signup" exact element={<Signup />} />
            <Route path="/auth/forgot-password" exact element={<ForgotPassword />} />
            <Route path="/auth/login-with-code" exact element={<LoginWithCode />} />
            <Route path="/auth/change-password" exact element={<ChangePassword />} />
            <Route path="/auth/logout" exact element={<Logout />} />
            <Route path="/super-admin/login" exact element={<SuperAdminLogin />} />
            <Route path="/super-admin/dashboard" exact element={<SuperAdminDashboard />} />
            <Route path="/super-admin/users" exact element={<UserManagement />} />
            <Route path="/super-admin/companies" exact element={<CompanyManagement />} />
            <Route path="/super-admin/companies/:companyId/view" exact element={<CompanyDataView />} />
            <Route path="/super-admin/products" exact element={<ProductManagement />} />
            <Route path="/super-admin/book-publishers" exact element={<BookPublisherManagement />} />
            <Route path="/super-admin/product-categories" exact element={<ProductCategoryManagement />} />
            <Route path="/super-admin/product-currencies" exact element={<ProductCurrencyManagement />} />
            {/*         <Route path='/auth/register' exact element={<Register />} /> */}
            <Route path="/hr/staffs" exact element={<UserList />} />
            <Route path="/hr/staffs/:id" exact element={<DetailStaff />} />
            <Route path="/hr/staffs/:id/update" element={<UpdateStaff />} />

            <Route path="/role" exact element={<RoleList />} />
            <Route path="/role/:id" element={<DetailRole />} />
            <Route path="/role/permit/:id/" element={<AddPermission />} />

            <Route path="/account" exact element={<Account />} />
            <Route path="/account/:id" element={<DetailAccount />} />
            <Route
              path="/account/trial-balance"
              exact
              element={<TrialBalance />}
            />
            <Route
              path="/account/balance-sheet"
              exact
              element={<BalanceSheet />}
            />
            <Route path="/account/income" exact element={<IncomeStatement />} />
            <Route path="/account/profit-and-loss" exact element={<ProfitAndLoss />} />
            <Route path="/account/party-wise-profit-loss" exact element={<PartyWiseProfitLoss />} />
            <Route path="/account/party-statement" exact element={<PartyStatement />} />
            <Route path="/account/customer-supplier-summary" exact element={<CustomerSupplierSummaryReport />} />
            <Route path="/designation" exact element={<Designation />} />
            <Route path="/designation/:id" element={<DetailDesignation />} />
            <Route
              path="/designation/:id/update"
              element={<UpdateDesignation />}
            />

            <Route path="/pos" exact element={<Pos />} />

            <Route path="/invoice-setting" exact element={<InvoiceSetting />} />
            <Route path="/location" exact element={<Location />} />
          </Routes>
        </Main>
      </BrowserRouter>
    </div>
  );
}

export default App;
